import { graphql, StaticQuery } from 'gatsby';
import React from 'react';
import Photos from './photos';

const Gallery = (props) => (
    <div>
        <StaticQuery
            query={graphql`
            {
                allGalleryYaml {
                    edges {
                        node {
                            title
                            image {
                                id
                                childImageSharp {
                                    fluid {
                                        ...GatsbyImageSharpFluid
                                        originalImg
                                    }
                                }
                            }
                        }
                    }
                }
            }
            `}
            render={data => (
                <Photos
                    images={data.allGalleryYaml.edges.map(({ node }) => ({
                        id: node.image.id,
                        ...node.image.childImageSharp.fluid,
                        caption: `${node.title}`,
                    }))}
                    itemsPerRow={[2, 3]}
                />
            )}
        />
    </div>
);

export default Gallery;
